<template>
  <div class="">
    <div v-if="computedConnectAccount" class="text-center">
      <p v-if="type === 'showSeries'" class="text-lg my-2">
          A bank account has been configured for your account.
      </p>
      <button class="link mr-2 text-lg font-bold" @click="createExpressAccountLink">Click here to go to Stripe Dashboard</button>
      <div class="mt-2 border-t border-gray-300 text-left max-w-xl mx-auto">
        <dl class="divide-y divide-gray-200">
          <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Account Status</dt>
            <dd class="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0 text-center">
              <template v-if="accountStatus === 'complete'">
                <span class="inline-flex items-center rounded-md bg-green-200 px-2.5 py-1 text-xs font-medium text-green-700 ml-1">{{ accountStatus.toUpperCase() }}</span>
              </template>
              <template v-else-if="accountStatus === 'enabled'">
                <span class="inline-flex items-center rounded-md bg-blue-200 px-2.5 py-1 text-xs font-medium text-blue-700 ml-1">{{ accountStatus.toUpperCase() }}</span>
              </template>
              <template v-else-if="accountStatus === 'restricted soon'">
                <p class="text-sm"><span class="inline-flex items-center rounded-md bg-yellow-200 px-2.5 py-1 text-xs font-medium text-yellow-700 ml-1">{{ accountStatus.toUpperCase() }}</span> - Please provide the information listed below to avoid any pauses/interuptions in payouts.</p>
              </template>
              <template v-else>
                <p class="text-sm"> <span class="inline-flex items-center rounded-md bg-red-200 px-2.5 py-1 text-xs font-medium text-red-700 ml-1">{{ accountStatus.toUpperCase() }}</span> - {{ disabledReasons[connectAccount.account_details.requirements.disabled_reason] }}</p>
              </template>
            </dd>
          </div>
          <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" v-if="accountRequirementsCurrentlyDue.length">
            <dt class="text-sm font-medium leading-6 text-gray-900">Currently Due</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 text-center">
              <ul>
                <li v-for="item in accountRequirementsCurrentlyDue" :key="item">
                  {{ item }}
                </li>
              </ul>
            </dd>
          </div>
          <div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" v-if="eventuallyDueDiff.length">
            <dt class="text-sm font-medium leading-6 text-gray-900">Eventually Due</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 text-center">
              <ul>
                <li v-for="item in eventuallyDueDiff" :key="item">
                  <template v-if="!accountRequirementsCurrentlyDue.includes(item)">
                    {{ item }}
                  </template>
                </li>
              </ul>
            </dd>
          </div>
        </dl>
      </div>
      <p v-if="type === 'events' && accountStatus === 'complete'" class='my-2 text-sm text-gray-800 max-w-xl'>Payouts to your bank account are manually released, if you have available funds that you need for your show reach out to <strong>{{helpEmail}}</strong> to request a deposit.</p>
      <div class="pt-2 flex justify-center space-x-4 items-center">
        <a v-if="currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2'" class="btn-sm btn-blue" :href="`https://dashboard.stripe.com/connect/accounts/${computedConnectAccount.stripe_user_id}/activity`" target="_blank">View in Stripe</a>
        <button v-if="currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2'" @click="resetExpressAccount" class="btn-sm btn-red-outline">Delete Express Account</button>
      </div>
    </div>
    <div v-else class='max-w-lg mx-auto'>
      <div class="flex items-center">
        <p class="text-lg my-2">
          A bank account has not been configured to receive payouts.
          <button class="mt-1 btn-sm btn-blue-outline" @click="createConnectAccount">Click here to connect your bank account.</button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    connectAccount: Object,
    return_url: String,
    uuid: String,
    country: {
      default: 'US',
      type: String
    }
  },
  data () {
    return {
      newConnectAccount: null,
      disabledReasons: {
        'rejected.fraud': 'Account is rejected due to suspected fraud or illegal activity.',
        'rejected.other': 'Account is rejected for other reasons.',
        'rejected.terms_of_service': 'Account is rejected for violating terms of service.',
        'rejected.incomplete_verification': 'Account is rejected for incomplete verification requirements.',
        'requirements.past_due': 'Additional verification information is required to enable capabilities on this account.',
        'rquirements.pending_verification': 'Stripe is currently verifying information on the connected account. No action is required. ',
        'rejected.listed': 'Account is rejected for being on a list of prohibited businesses.',
        'listed': 'Account is on a list of prohibited businesses.',
        'under_review': 'Account is under review by Stripe'
      },
      currentlyDueItems: {

      }
    }
  },
  methods: {
    createConnectAccount () {
      this.$store.state.apiInstance.get(`/stripe/express/newAccount?type=${this.type}&user_id=${this.currentUser.user_id}&uuid=${this.uuid}&return_url=${this.return_url_full}&country=${this.country}`)
        .then(response => {
          if (response.data.data.connect_account) {
            this.newConnectAccount = response.data.data.connect_account
          }
          window.open(response.data.data.url, '_self')
        })
        .catch(() => {
          // console.log(error)
          alert('Error Opening Account Setup Page')
        })
    },
    createExpressAccountLink () {
      this.$store.state.apiInstance.get(`/stripe/express/accountLink?account_id=${this.computedConnectAccount.stripe_user_id}&return_url=${this.return_url_full}`)
        .then(response => {
          window.open(response.data.data.url)
        })
        .catch(() => {
          // console.log(error)
          alert('Error Opening Account Setup Page')
        })
    },
    resetExpressAccount () {
      this.notie.confirm({
        text: `Are you sure you want to reset this account?`,
        submitCallback: () => {
          this.$store.state.apiInstance.put(`/data/events/${this.uuid}`, {connect_account_id: null})
            .then(() => {
              this.$store.state.apiInstance.put(`/stripe/express/deleteAccount?account_id=${this.computedConnectAccount.stripe_user_id}`)
                .then(() => {
                  alert('Account Deleted In Stripe')
                })
                .catch(() => {
                  alert('Error Deleting Account In Stripe')
                })
              this.$emit('resetConnectAccount')
            })
        }
      })
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    computedConnectAccount () {
      if (this.connectAccount) {
        return this.connectAccount
      } else if (this.newConnectAccount) {
        return {
          stripe_user_id: this.newConnectAccount.account_deatils.id
        }
      } else {
        return null
      }
    },
    return_url_full () {
      return encodeURIComponent(`${process.env.VUE_APP_ROOT_URL}${this.return_url}`)
    },
    helpEmail () {
      if (this.$store.state.admin.adminData.show_specialist) {
        return this.$store.state.admin.adminData.show_specialist.email
      } else {
        return 'josh@showman.app'
      }
    },
    accountStatus () {
      let status = 'inactive'
      let account = this.connectAccount.account_details
      if (account.requirements.disabled_reason) {
        status = 'restricted'
      } else if (account.requirements.currently_due.length > 0) {
        status = 'restricted soon'
      } else if (account.requirements.eventually_due.length > 0) {
        status = 'enabled'
      } else if (account.charges_enabled && account.payouts_enabled) {
        status = 'complete'
      }
      return status
    },
    accountRequirementsCurrentlyDue () {
      let requirements = []
      this.connectAccount.account_details.requirements.currently_due.forEach(item => {
        if (item.includes('dob')) {
          if (!requirements.includes('Date of Birth')) {
            requirements.push('Date of Birth')
          }
        } else if (item.includes('verification.document')) {
          if (!requirements.includes('Identity Document')) {
            requirements.push('Identity Document')
          }
        } else if (item.includes('external_account')) {
          if (!requirements.includes('Bank Account')) {
            requirements.push('Bank Account')
          }
        } else if (item.includes('tos_acceptance')) {
          if (!requirements.includes('Accept Terms of Service')) {
            requirements.push('Accept Terms of Service')
          }
        } else if (item.includes('company.tax_id')) {
          if (!requirements.includes('Business Tax ID')) {
            requirements.push('Business Tax ID')
          }
        } else if (item.includes('individual.id_number')) {
          if (!requirements.includes('SSN')) {
            requirements.push('SSN')
          }
        } else if (item.includes('company.address')) {
          if (!requirements.includes('Business Address')) {
            requirements.push('Business Address')
          }
        } else if (item.includes('address')) {
          if (!requirements.includes('Address')) {
            requirements.push('Address')
          }
        } else if (item.includes('company.name')) {
          if (!requirements.includes('Company Name')) {
            requirements.push('Company Name')
          }
        } else if (item.includes('business_profile.url')) {
          if (!requirements.includes('Business Website')) {
            requirements.push('Business Website')
          }
        } else if (item.includes('individual.first_name')) {
          if (!requirements.includes('Representative Name')) {
            requirements.push('Representative Name')
          }
        } else if (item.includes('individual.ssn_last_4')) {
          if (!requirements.includes('Representative Last 4 SSN')) {
            requirements.push('Representative Last 4 SSN')
          }
        }
      })
      return requirements
    },
    accountRequirementsEventuallyDue () {
      let requirements = []
      this.connectAccount.account_details.requirements.eventually_due.forEach(item => {
        if (item.includes('dob')) {
          if (!requirements.includes('Date of Birth')) {
            requirements.push('Date of Birth')
          }
        } else if (item.includes('verification.document')) {
          if (!requirements.includes('Identity Document')) {
            requirements.push('Identity Document')
          }
        } else if (item.includes('external_account')) {
          if (!requirements.includes('Bank Account')) {
            requirements.push('Bank Account')
          }
        } else if (item.includes('tos_acceptance')) {
          if (!requirements.includes('Accept Terms of Service')) {
            requirements.push('Accept Terms of Service')
          }
        } else if (item.includes('company.tax_id')) {
          if (!requirements.includes('Business Tax ID')) {
            requirements.push('Business Tax ID')
          }
        } else if (item.includes('individual.id_number')) {
          if (!requirements.includes('SSN')) {
            requirements.push('SSN')
          }
        } else if (item.includes('company.address')) {
          if (!requirements.includes('Business Address')) {
            requirements.push('Business Address')
          }
        } else if (item.includes('address')) {
          if (!requirements.includes('Address')) {
            requirements.push('Address')
          }
        } else if (item.includes('company.name')) {
          if (!requirements.includes('Company Name')) {
            requirements.push('Company Name')
          }
        } else if (item.includes('business_profile.url')) {
          if (!requirements.includes('Business Website')) {
            requirements.push('Business Website')
          }
        } else if (item.includes('individual.first_name')) {
          if (!requirements.includes('Representative Name')) {
            requirements.push('Representative Name')
          }
        } else if (item.includes('individual.ssn_last_4')) {
          if (!requirements.includes('Representative Last 4 SSN')) {
            requirements.push('Representative Last 4 SSN')
          }
        }
      })
      return requirements
    },
    eventuallyDueDiff () {
      return this.accountRequirementsEventuallyDue.filter(item => !this.accountRequirementsCurrentlyDue.includes(item))
    }
  }
}
</script>

<style>

</style>
